module.exports = __webpack_public_path__ + "img/nambia-logo-icon.2360f3d1.png";